import styled, { css, keyframes } from "styled-components";
const rotateRightKeyFrames = (rotationDeg) => keyframes `
  to {
    transform: rotate(${rotationDeg});
  }
`;
const rotateLeftKeyFrames = (initialRotationDeg) => keyframes `
  from {
    transform: rotate(${initialRotationDeg});
  }
  to {
    transform: rotate(0deg);
  }
`;
function animationStyles({ isOpened, isIconLeft, }) {
    let animationDuration = "0.3s";
    if (isIconLeft) {
        return isOpened
            ? css `
          animation: ${rotateRightKeyFrames("90deg")} ${animationDuration}
            ease-in both;
        `
            : css `
          animation: ${rotateLeftKeyFrames("90deg")} ${animationDuration}
            ease-out both;
        `;
    }
    return isOpened
        ? css `
        animation: ${rotateRightKeyFrames("-180deg")} ${animationDuration}
          ease-in both;
      `
        : css `
        animation: ${rotateLeftKeyFrames("-180deg")} ${animationDuration}
          ease-out both;
      `;
}
// noinspection CssInvalidPropertyValue
export const StyledAccordionTitleWrapper = styled.div `
  &&& {
    transition-timing-function: linear;
    transition-property: border-bottom-color;
    transition-duration: 0s;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    ${({ isOpened }) => !isOpened ? `transition-delay: 290ms;` : "transition-delay: 0ms;"};

    border-bottom-color: ${({ isIconRight, theme, stylingType }) => isIconRight && stylingType !== "withBackground"
    ? `rgba(${theme.colors.transparentBlack}, 0.16);`
    : "transparent"};

    display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;

    color: ${({ theme, disabled }) => disabled
    ? `rgba(${theme.colors.transparentBlack}, 0.26);`
    : theme.colors.black};

    & > * {
      margin-top: 0;
      margin-bottom: 0;
      font-size: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[0]
    : theme.fontTokens.font12[0]};
      line-height: ${({ theme, fontSize }) => fontSize === "p1"
    ? theme.fontTokens.font11[1]
    : theme.fontTokens.font12[1]};
      font-weight: ${({ theme, titleBold }) => titleBold ? theme.fontWeights.bold : theme.fontWeights.medium};
    }

    ${({ disabled }) => (disabled ? "" : "cursor: pointer")};
    ${({ isIconLeft }) => !isIconLeft ? "justify-content: space-between;" : ""};

    ${({ stylingType }) => stylingType === "withBackground" ? `margin-bottom: 0.5rem;` : ""};
    ${({ stylingType, theme }) => stylingType === "withBackground"
    ? `background-color: rgba(${theme.colors.transparentBlack}, 0.04);`
    : ""};

    ${({ fontSize }) => fontSize === "p1" ? "min-height: 2.75rem" : "min-height: 2.5rem"};

    ${({ isIconLeft }) => {
    if (isIconLeft)
        return "padding-right: 0.5rem;";
    return "padding-left: 0.5rem;";
}}

    span:first-child {
      ${({ fontSize }) => fontSize === "p1" ? "min-width: 3rem" : "min-width: 2.5rem"};
    }

    div {
      ${({ fontSize }) => fontSize === "p1"
    ? "height: calc(2.75rem - 2px)"
    : "height: calc(2.5rem - 2px)"};
      ${({ fontSize }) => fontSize === "p1" ? "min-width: 3rem" : "min-width: 2.5rem"};
    }

    div span {
      ${animationStyles}

      ${({ fontSize }) => fontSize === "p1"
    ? "height: calc(2.75rem - 2px)"
    : "height: calc(2.5rem - 2px)"};
      ${({ fontSize }) => fontSize === "p1" ? "min-width: 3rem" : "min-width: 2.5rem"};
    }

    @media (hover: hover) {
      &:hover {
        ${({ theme, disabled, hovered, stylingType }) => {
    if (hovered) {
        if (stylingType === "withBackground" && !disabled)
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.08);`;
        if (stylingType !== "withBackground" && !disabled)
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.04);`;
    }
    return "";
}}
      }
    }

    &:active {
      ${({ theme }) => theme.global.disableTapHighlight}

      ${({ theme, isActive, stylingType, isIconLeft }) => {
    if (isActive) {
        if (stylingType === "withBackground")
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.12);`;
        if (!isIconLeft)
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.08);`;
        return `background-color: rgba(${theme.colors.transparentBlack}, 0.06);`;
    }
    return "";
}}
    }

    &:focus {
      outline: none;
      border: ${({ theme, focused, disabled }) => focused && !disabled
    ? `1px solid ${theme.colors.primaryLight}; outline: 1px solid ${theme.colors.primaryLight};`
    : ""};
    }

    div:last-child {
      position: absolute;
      right: -1px;
      margin-left: auto;
    }

    @media ${({ theme }) => theme.device.touch} {
      height: 2.75rem;

      button span,
      div span {
        min-height: 2.75rem;
      }
      span:first-child {
        min-width: 2.75rem;
      }
    }
  }
`;
export const StyledAccordionTitle = styled.span `
  display: inline-block;
  overflow: hidden;
  padding: ${({ fontSize }) => fontSize === "p1" ? "0.5rem 3rem 0 0;" : "0.563rem 3rem 0 0;"};

  ${({ isIconLeft, stylingType }) => !isIconLeft || stylingType === "withBackground"
    ? "margin-right: 2.5rem"
    : ""};

  @media ${({ theme }) => theme.device.touch} {
    ${({ isIconLeft, stylingType }) => !isIconLeft || stylingType === "withBackground"
    ? "margin-right: 2.75rem"
    : ""};
  }
`;
export const StyledAccordionTitleContainer = styled.div `
  ${({ titleMargin }) => titleMargin
    ? `padding-left: ${titleMargin.left};padding-right: ${titleMargin.right};`
    : ""}
`;
